export default {
  install(Vue) {
    Vue.prototype.get_workplace = async function () {
      const api = `${window.endpoints.api}/WorkPlace`;
      const response = await this.$http.get(api);
      return response.data;
    };
  },
};
